module.exports = __webpack_public_path__ + "static/media/instagram-white.95c01106.svg";